<template>
  <div v-if="value" class="news-badge-container">
    <v-badge :value="value" :color="color" :dot="dot" :content="text" inline />
  </div>
</template>

<script>
export default {
  name: 'NewsBadge',
  props: {
    variant: {
      type: String,
      default: 'dot',
      validator: (value) => ['dot', 'text'].includes(value),
    },
    value: {
      type: Boolean,
      default: true,
    },
    text: {
      type: String,
      default: 'Novo',
    },
    color: {
      type: String,
      default: '#0063C6',
    },
  },
  computed: {
    dot() {
      return this.variant === 'dot'
    },
  },
}
</script>

<style lang="scss" scoped>
.news-badge-container {
  display: flex;
}
::v-deep .v-badge--dot {
  .v-badge__badge {
    border: 2px solid #b3d0ee !important;
  }
}
</style>
